// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__h6WDF","inner":"Form_inner__2gHDR","range":"Form_range__ZD_4S","name":"Form_name__3HxqO","actions":"Form_actions__2glx9"};